<template>
    <div class="bg-white flex flex-col min-h-svh max-h-svh">
        <nav>
            <div class="max-w-6xl mx-auto py-4 px-4 lg:px-0">
                <div class="flex items-center justify-between">
                    <div class="flex items-center">
                        <div class="shrink-0">
                            <a href="/">
                                <AppLogo :appName="appName" />
                            </a>
                        </div>
                    </div>
                    <div>
                        <div class="flex items-center">
                            <ApiForm
                                :url="RoutePathAppEnum.Auth_Logout"
                                method="POST"
                                ref="logoutApiFormRef"
                            />
                            <button
                                @click="logoutApiFormRef?.submit()"
                                type="submit"
                                class="block w-full text-left rounded-lg2 px-3 py-2 text-sm font-medium text-gray-500 hover:bg-gray-200"
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>

        <main
            class="flex-1 overflow-y-auto bg-gray-50 border-y border-stone-200"
        >
            <div class="max-w-5xl mx-auto py-4 px-4 lg:px-0">
                <slot name="content" />
            </div>
        </main>

        <footer>
            <div class="max-w-6xl mx-auto py-4 px-4 lg:px-0">
                <div class="flex justify-between items-center">
                    <div>
                        <slot name="footerLeft" />
                    </div>
                    <div>
                        <slot name="footerRight" />
                    </div>
                </div>
            </div>
        </footer>

        <FlashMessage />
    </div>
</template>

<script setup lang="ts">
    import { onBeforeMount, ref } from 'vue'
    import AppLogo from '@/Shared/Component/AppLogo.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
    import FlashMessage from '@/Shared/Component/FlashMessage.vue'
    import type { FlashStatusType } from '@/Shared/AutoGenerated/Main'
    import useFlash from '@/Shared/Hook/useFlash'

    interface OnboardingLayoutProps {
        appName: string
        flashStatus: FlashStatusType | null
    }

    const props = defineProps<OnboardingLayoutProps>()
    const logoutApiFormRef = ref<ApiFormRefType>(null)

    onBeforeMount(() => {
        if (!props.flashStatus) {
            return
        }

        useFlash().display(props.flashStatus)
    })
</script>
